export const MenuItems = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "Guide",
    path: "/guide",
  },
  {
    title: "Attractions",
    path: "/attraction/0",
  },
  {
    title: "Accessible Melbourne",
    path: "/map",
  },
];
